import { useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { WhatsNewStoryItem } from "domains/whatsNew/components/WhatsNewStoryItem";
import { getWhatsNewStories } from "domains/whatsNew/selectors";

export const WhatsNewModal = () => {
  const stories = useSelector(getWhatsNewStories);
  const translate = useTranslate();

  return (
    <>
      <ModalHeader title={translate("app.whatsNew.title")} />
      <div>
        {stories?.map((story) => (
          <WhatsNewStoryItem key={story.seq} {...story} />
        ))}
      </div>
    </>
  );
};
